import getUrlParam from './getUrlParam';
let urlCode = getUrlParam('code');
let urlTypeFlag = getUrlParam('typeFlag');
if (urlCode !== '' && urlTypeFlag !== '' && urlTypeFlag === '3') {
  window.history.replaceState('', '', (window.location.search).replace('code', 'linecode'));
}
